import api from "../../api";
import { COUNTRIES_WITH_COMPANY_REGISTER_INTEGRATIONS } from "../../constants/integrations";

export const hasIntegration = (country?: string) =>
  country ? COUNTRIES_WITH_COMPANY_REGISTER_INTEGRATIONS.includes(country as api.CountryEnum) : false;
